import React from 'react';
import Axios from 'axios';
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import moment from 'moment';

const cstTableHeaders = [
	'', 'ID', 'Date', 'Sous-saison', 'Prog', 'Éq1', 'Éq2', 'Rds 1', 'Rds 2', 'Pts 1', 'Pts 2', 'STATS', ''];

const cstDefaultSortOrder = [
	'', 'desc', 'desc', 'desc', 'asc', 'asc', 'desc', 'desc', 'desc', 'desc', 'desc', 'desc', ''];

const cstDefaultSortFieldIdx = 1;	// Date
const cstIDcolumnIdx = 1;

class ScoresheetsList extends React.Component {

  constructor(props) {
		super(props);

		this.state = {
			scoresheetsTable: [],
			seasonId: '0',

			sortFieldIdx: cstDefaultSortFieldIdx,
			sortOrder: cstDefaultSortOrder[cstDefaultSortFieldIdx],

			deleteInProgress: false,
			loading: true
		};
	
		this.loadScoresheetsTable = this.loadScoresheetsTable.bind(this);
		this.createDataTable = this.createDataTable.bind(this);
		this.sortdataTable = this.sortdataTable.bind(this);
		this.editScoresheet = this.editScoresheet.bind(this);
		this.deleteScoresheet = this.deleteScoresheet.bind(this);
		this.displayModule = this.displayModule.bind(this);
		this.displayData = this.displayData.bind(this);
		this.createTableHdrRow = this.createTableHdrRow.bind(this);
		this.createEmptyDataRow = this.createEmptyDataRow.bind(this);
		this.createDataRow = this.createDataRow.bind(this);
		this.createDataCell = this.createDataCell.bind(this);
		this.handleSortTable = this.handleSortTable.bind(this);
		this.deletingModal = this.deletingModal.bind(this);
	}

	componentDidMount() {
		// console.log('ScoresheetsList: componentDidMount');
		//console.log('this.props.season._id', this.props.season._id);
		var seasonId = this.props.season._id;
		this.setState({
			seasonId: seasonId,
			loading: true
		})
		this.loadScoresheetsTable(seasonId);
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		// console.log('ScoresheetsList: UNSAFE_componentWillReceiveProps');
		//console.log('nextProps.season._id', nextProps.season._id);
		var seasonId = nextProps.season._id;
		this.setState({
			seasonId: seasonId,
			loading: true
		})
   	this.loadScoresheetsTable(seasonId);
	}

  loadScoresheetsTable(seasonId) {
    // ScoresheetsList
    // Get scoresheetsTable for this seasonId (ScoresheetsList)
		// console.log('ScoresheetsList: loadScoresheetsTable');
		// console.log('seasonId', seasonId);

    var _this = this;
    if (seasonId !== "0") {
      Axios.get('/api/scoresheets/All/seasonId/' + seasonId).then(function(response) {
				// console.log('loadScoresheetsTable data received: ', response.data.length);
      	_this.createDataTable(response.data);
      });
    }
  }

	createDataTable(dataResults) {
		var _this = this;
		var dataTable = [];
		var compiledText = '';

		//console.log('dataResults');
		//console.log(dataResults);

		// Parse results
		dataResults.forEach(function(result, resultIdx) {

			var dataTableRow = [];
 
			compiledText = '';
			if(result.compiled) {
				compiledText = 'OK';
			}
			if (result.specialTable != null) {
				if (result.specialTable.length !== 0) {
					compiledText += (compiledText.length !== 0) ? " " : "";
					compiledText += '[SP]';
				}
			}

			var team1Name = result.team1Name;
			var team2Name = result.team2Name;

			// Individual leagues, display first player in faked team
			if(_this.props.season.formatTeamIndiv === "INDIV") {
				team1Name = result.team1firstPlayerName;
				team2Name = result.team2firstPlayerName;
			}

			// dataTableRow.push(0);		// rank
			dataTableRow.push(result._id);
			dataTableRow.push(moment(result.date).utc().format("YYYY-MM-DD"));
			dataTableRow.push(result.subSeason.name);
			dataTableRow.push(result.week);
			dataTableRow.push(team1Name);
			dataTableRow.push(team2Name);
			dataTableRow.push(result.team1TotalRoundPts);
			dataTableRow.push(result.team2TotalRoundPts);
			dataTableRow.push(result.team1TotalPts);
			dataTableRow.push(result.team2TotalPts);
			dataTableRow.push(compiledText);

			// Build table
			dataTable.push(dataTableRow.slice());
		});

		// First data sort
		var sortFieldIdx = this.state.sortFieldIdx;
		var sortOrder = this.state.sortOrder;

		_this.sortdataTable(dataTable, sortFieldIdx, sortOrder);
	}

	sortdataTable(dataTable, sortFieldIdx, sortOrder) {

		// Manage empty data
		if (dataTable.length !== 0) {

			var sortSign = 1;
			if (sortOrder === 'desc') { 
				sortSign = -1; 
			}

			dataTable.sort(function(a, b) {

				var valueA = a[sortFieldIdx];
				var valueB = b[sortFieldIdx];
				var compVal = 0;

				switch(typeof a[sortFieldIdx]) {
			    case "date":
						compVal = new Date(valueA) - new Date(valueB);
		        break;
			    case "string":
						compVal = valueA.localeCompare(valueB);
		        break;
			    case "number":
						compVal = valueA - valueB;
		        break;
			    default:
		        break;
				}

				if (compVal !== 0) {
					return (sortSign * compVal);
				} else {

					compVal = new Date(b[1]) - new Date(a[1]);
					if (compVal !== 0) {
						return compVal;
					} else {
						return (b[0].localeCompare(a[0]));
					}
				}
			});
		}

		this.setState({
			dataTable: dataTable,
			sortFieldIdx: sortFieldIdx,
			sortOrder: sortOrder,
			deleteInProgress: false,
			loading: false
		});
	}

	editScoresheet(e) {
		var elemInfo = e.target.name.split(".");
		var scoresheetEditId = elemInfo[1];
		this.props.editScoresheet(scoresheetEditId);
	}

	deleteScoresheet(e) {
		var elemInfo = e.target.name.split(".");
		var scoresheetEditId = elemInfo[1];
		var _this = this;

		// Prevent double sumbit of tournament
		if (this.state.deleteInProgress) {
			console.log('deleting rejected !');
			return;
		}

		if (window.confirm('Retirer la feuille de pointage ' + scoresheetEditId + '\nCliquer sur OK pour confirmer')) {

			this.setState({
				deleteInProgress: true
			});

			Axios.delete('/api/scoresheets/' + scoresheetEditId).then(function(response) {
				_this.loadScoresheetsTable(_this.state.seasonId);
			});
		}
	}

	render() {
		// console.log('Scoresheet List: RENDER');
		return (
      <div className="row">
      <div className="col-md-12">
        <br/>
        <h5>Liste des feuilles de pointage</h5>
        <br/>
				{this.displayModule()}
				{this.deletingModal()}
			</div>
			</div>
		);
	}

	displayModule() {
		if (this.state.loading) {
			return ( this.displaySpinner() );
		} else {
			return ( this.displayData() );
		}
	}

	displaySpinner() {
		return (
  		<div className="sk-three-bounce">
    		<div className="sk-child sk-bounce1"></div>
    		<div className="sk-child sk-bounce2"></div>
    		<div className="sk-child sk-bounce3"></div>
  		</div>
  	);
	}

	displayData() {
		// console.log('ScoresheetsList displayData', this.state.dataTable.length);
		return (
			<div className="table-responsive tableFixHeader resizeVerticalStandings">
			<table className="table table-striped table-hover table-sm small">

			<thead>
				<tr>
				{cstTableHeaders.map(this.createTableHdrRow)}
				</tr>
			</thead>

			<tbody>
				{this.state.dataTable.length !== 0 ? 
					this.state.dataTable.map(this.createDataRow) : 
					this.createEmptyDataRow()}
			</tbody>
			</table>
			</div>
		);
	}

	createTableHdrRow(hdrItem, hdrIdx) {
		// ID Visible only in master mode
		if (!this.props.isMasterAdmin && (hdrIdx === cstIDcolumnIdx)) {
			return;
		}

		var classNameStr = '';
		var onClickAction = function() {};

		// Individual leagues, display first player in faked team
		if(this.props.season.formatTeamIndiv === "INDIV") {
			if (hdrItem === 'Éq1') {
				hdrItem = 'Joueur 1';
			}
			if (hdrItem === 'Éq2') {
				hdrItem = 'Joueur 2';
			}
		}

		// Sort with arrows
		// No sort on Rank (column 0)
		if (cstDefaultSortOrder[hdrIdx] !== '') {
			onClickAction = this.handleSortTable;
			classNameStr = 'statelo-sorting';
			if(hdrIdx === (this.state.sortFieldIdx + 1)) {
				if (this.state.sortOrder === "asc") {
					classNameStr += ' statelo-sorting_asc';
				} else {
					classNameStr += ' statelo-sorting_desc';
				}
			}
		}

		return (
			<th key={"colid." + hdrIdx}
				id={"colid." + hdrIdx} 
				className={classNameStr}
				onClick={onClickAction}>
				{hdrItem}
			</th>
		);
	}

  createEmptyDataRow() {
		return (
			<tr key={'te.0'}>
				<td colSpan="99">Aucune entrée</td>
	    </tr>
    );
  }

  createDataRow(dataRow, dataRowIdx) {
		return (
			<tr key={'te.' + dataRowIdx}>
				<td><input name={'edit.' + dataRow[0]} type="button" onClick={this.editScoresheet} value="Éditer"/></td>
					{dataRow.map(this.createDataCell)}
				<td><input name={'del.' + dataRow[0]} type="button" onClick={this.deleteScoresheet} value="Supprimer"/></td>
      </tr>
    );
  }

 	createDataCell(dataCell, dataCellIdx) {
		// ID Visible only in master mode
		if (!this.props.isMasterAdmin && (dataCellIdx === cstIDcolumnIdx - 1)) {
			return;
		}

		return (
			<td key={"tdcell." + dataCellIdx}>{dataCell}</td>
		);
	}

	handleSortTable(e) {
		var _this = this;
		var sortFieldIdx = parseInt(e.target.id.split(".")[1], 10);

		// Special
		sortFieldIdx -= 1;	// first column is not in dataTable (edit button)

		var dataTable = this.state.dataTable;
		var sortOrder = this.state.sortOrder;
		var prevSortFieldIdx = this.state.sortFieldIdx;

		// Toggle sort order
		if (prevSortFieldIdx === sortFieldIdx) {
			if (sortOrder === 'asc') {
				sortOrder = 'desc';
			} else {
				sortOrder = 'asc';
			}
		} else {
			sortOrder = cstDefaultSortOrder[sortFieldIdx];
		}

		this.sortdataTable(dataTable, sortFieldIdx, sortOrder);
	}

	deletingModal() {
		return (
			<Modal 
				isOpen={this.state.deleteInProgress} size="sm"
				className={this.props.className}>
				<ModalHeader>
					Suppression en cours
				</ModalHeader>

				<ModalBody>
					<p>Veuillez patienter...</p>
				</ModalBody>
      </Modal>
    )
	}

}

export default ScoresheetsList;